// extracted by mini-css-extract-plugin
export default {"form":"partials_form__YXhMf","google":"partials_google__-96Ec","emailbtn":"partials_emailbtn__UNSOU","option":"partials_option__mXYiS"};